export default "__VITE_PUBLIC_ASSET__f94bf64b__"